import { SETTINGS_CATEGORIES } from '@/vue_widgets/mlap/settings/index/categories'

export default {
  items: [
    {
      label: 'MLAP Projects',
      href: '/mlap',
      icon: 'fa-solid fa-diagram-project',
      activeUrl: '/mlap'
    },
    {
      label: 'MLAP Settings',
      href: '/mlap/settings',
      icon: 'fa-solid fa-gear',
      activeUrl: '/mlap/settings',
      expanded: true,
      children: SETTINGS_CATEGORIES.map(({ title, href, icon }) => ({
        label: title, href, icon, activeUrl: href
      }))
    }
  ]
}
